import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { Select } from 'components/FormControl';

export default function SecurityInformation({ viewOnly, control, errors, value }) {
  // #region Data
  const { t } = useTranslation();
  const securityInformation = [
    { value: 'public', name: t('r09.securityInformation.public') },
    { value: 'restricted', name: t('r09.securityInformation.restricted') },
    { value: 'confidential', name: t('r09.securityInformation.confidential') },
  ];

  // #endregion Data
  return (
    <div className="ml-2">
      {viewOnly ? (
        <p className="mb-2">{t(`r09.securityInformation.${value}`)}</p>
      ) : (
        <div className="col-12 sm:col-6 md:col-4">
          <Select
            name="securitySeverity"
            isRequired
            options={securityInformation}
            inputField="value"
            control={control}
            errors={errors}
          />
        </div>
      )}
    </div>
  );
}

SecurityInformation.propTypes = {
  viewOnly: PropTypes.bool,
  errors: PropTypes.shape({}).isRequired,
  control: PropTypes.shape({}).isRequired,
  value: PropTypes.string,
};

SecurityInformation.defaultProps = {
  viewOnly: false,
  value: '',
};
